module.exports = __webpack_public_path__ + "static/media/riskHighBloodPressure.e9453ad5.mp3";